import React, { useEffect } from 'react'

import { Box, ExternalLink, RadioButtons } from '@labrav/react-components'
import { Typography } from '@mui/material'
import { useStyles } from './Renewal.styles'
import { KeyValue } from '../../../modules/privateOffer/privateOfferCreation/types'
import { dealType } from '../../../modules/privateOffer/types'
import { dealTypes, gcpRenewalLink } from './utils'

export type OfferedTypes = 'offer' | 'resale authorization'
export type RenewalProps = {
  handleDetailsChange: (data: KeyValue) => void
  channel: dealType | null
}

const link = gcpRenewalLink
export const RenewalGCP = React.memo(
  ({ handleDetailsChange, channel }: RenewalProps) => {
    const { classes } = useStyles()
    useEffect(() => {
      handleDetailsChange({ key: 'dealType', value: 'NEW' })
    }, [])
    const handleUpdate =
      (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        handleDetailsChange({ key, value: event.target.value })
      }

    return (
      <Box heading={'Renewal'} subHeading={''}>
        <div>
          {
            <>
              <div className={classes.subHeadingContainer}>
                <Typography
                  className={classes.labelText}
                  data-testid="renewal-type-subheading"
                >
                  Select offer type to determine applicable google listing fees
                  according to guidlines mentined
                  {link && (
                    <>
                      {' '}
                      <ExternalLink href={link}>{'here'}</ExternalLink>
                    </>
                  )}
                </Typography>
              </div>
              <RadioButtons
                checkedValue={{ key: 'channel', value: channel || '' }}
                handleChange={handleUpdate('dealType')}
                radioButtonMappings={dealTypes}
              />
            </>
          }
        </div>
      </Box>
    )
  }
)
